import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Slide from '@mui/material/Slide';
import SimpleBar from 'simplebar-react';
import { TransitionProps } from '@mui/material/transitions';

import PatientInfo from 'src/components/counseling/PatientInfo';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import { getAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import { useNotify } from 'src/context/ContextNotify';
import { getField } from 'src/common/helper';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction='left' ref={ref} {...props} />;
});

interface DialogDetailProps {
  open: boolean;
  patientId: number | null;
  id: number | null;
  onClose: () => void;
  openForm: (data: any) => void;
};

const DialogDetail: React.FC<DialogDetailProps> = (props) => {
  const notifyContext = useNotify();
  const [patient, setPatient] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleClose = () => {
    props.onClose();
  };

  const handleButtonClick = () => {
    const data = {
      patientid: props.patientId,
      counselingid: props.id,
    };
    props.openForm(data);
  };

  const getDataDetail = () => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      setIsLoading(true);
      getAPI(
        `/patient/view?patientid=${props.patientId}&token=${token}`
      )
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setPatient(getField(res.data, 'patient', {}));
            setIsLoading(false);
          }
          if (res.code === 403 || res.code === 500 || res.code === 501) {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg,
              type: 'error',
            });
          }
        })
        .finally(() => { });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  useEffect(() => {
    if (props.open) {
      getDataDetail();
    }
    // eslint-disable-next-line
  }, [props.open]);

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      TransitionComponent={Transition}
      sx={{
        position: 'fixed !important',
        top: '0px !important',
        right: '0px !important',
        left: 'auto',
        bottom: 'auto',
        p: '0px',
        zIndex: 2147483647,
        '& .MuiDialog-paper': {
          m: '0px !important',
          width: '302px',
          height: '100vh',
          bgcolor: '#FAFDFF',
          borderRadius: '16px 0px 0px 16px',
        },
      }}
    >
      <DialogTitle id='scroll-dialog-title' sx={{ p: '5px 24px 0 0' }}>
        <Stack direction={'row'} justifyContent={'flex-end'}>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        sx={{
          p: '0px 10px 24px 24px',
          '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
            backgroundColor: '#CCD1D9',
          },
        }}
      >
        <SimpleBar
          style={{ height: 'calc(100vh - 140px)', borderWidth: '18px' }}
        >
          <Box
            sx={{
              pr: '14px',
            }}
          >
            <Stack spacing='15px' height={'calc(100vh - 69px)'}>
              <PatientInfo patient={patient} dataCounseling={{}} isLoading={isLoading} />
            </Stack>
          </Box>
        </SimpleBar>
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: 'right',
          padding: '16px',
        }}
      >
        <BtnOutlineGradient
          text='キャンセル'
          handleButtonClick={handleClose}
          disabled={isLoading}
        />
        <BtnGradient
          text='登録'
          handleButtonClick={handleButtonClick}
          disabled={isLoading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DialogDetail;
